<template>
  <div ref="companyPage" id="companyPage">
    <div class="w-full">
      <vx-card id="companiesCard" :title="$siteTypeId() == 1 ? 'Classrooms' : 'Companies'" v-show="!isCompanyListHidden">
        <vs-table v-if="$siteTypeId() == 1" stripe ref="companiesTable" class="vs-con-loading__container" single @selected="handleSelectedCompany" pagination max-items="10" search :data="companies">
          <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
            <!-- ADD NEW -->
            <div class="p-3 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewCompany">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add New</span>
            </div>
          </div>
          <template slot="thead">
            <vs-th sort-key="name">Name</vs-th>
            <vs-th sort-key="courseName">Subject</vs-th>
            <vs-th sort-key="teacherName">Teacher Name</vs-th>
            <vs-th sort-key="teacherContactNumber">Teacher Contact Number</vs-th>
            <vs-th sort-key="teacherEmail">Teacher Email</vs-th>
            <vs-th sort-key="totalStudents">Students</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="company" :key="indextr" v-for="(company, indextr) in data">

              <vs-td :data="data[indextr].name">
                {{ company.name }}
              </vs-td>

              <vs-td :data="data[indextr].courseName">
                {{ company.courseName ? company.courseName : 'N/A' }}
              </vs-td>

              <vs-td :data="data[indextr].teacherFullName">
                {{ company.teacherFullName ? company.teacherFullName : 'N/A' }}
              </vs-td>

              <vs-td :data="data[indextr].teacherContactNumber">
                {{ company.teacherContactNumber ? company.teacherContactNumber : 'N/A' }}
              </vs-td>

              <vs-td :data="data[indextr].teacherEmail">
                {{ company.teacherEmail ? company.teacherEmail : 'N/A' }}
              </vs-td>

              <vs-td :data="data[indextr].totalStudents">
                <vs-chip color="success"><strong>{{ company.totalStudents }}</strong></vs-chip>
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>
        
        
        <vs-table v-else stripe ref="companiesTable" class="vs-con-loading__container" single @selected="handleSelectedCompany" pagination max-items="10" search :data="companies">
          <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
            <!-- ADD NEW -->
            <div class="p-3 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewCompany">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add New</span>
            </div>
          </div>
          <template slot="thead">
            <vs-th sort-key="name">Name</vs-th>
            <vs-th sort-key="contactPersonName">Contact Person</vs-th>
            <vs-th sort-key="contactMobile">Contact Number</vs-th>
            <vs-th sort-key="contactEmail">Contact Email</vs-th>
            <vs-th sort-key="totalStudents">Students</vs-th>
            <vs-th sort-key="balance">Balance</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="company" :key="indextr" v-for="(company, indextr) in data">

              <vs-td :data="data[indextr].name">
                {{ company.name }}
              </vs-td>

              <vs-td :data="data[indextr].contactPersonName">
                {{ company.contactPersonName }}
              </vs-td>

              <vs-td :data="data[indextr].contactMobile">
                {{ company.contactMobile }}
              </vs-td>

              <vs-td :data="data[indextr].contactEmail">
                {{ company.contactEmail }}
              </vs-td>

              <vs-td :data="data[indextr].totalStudents">
                <vs-chip color="success"><strong>{{ company.totalStudents }}</strong></vs-chip>
              </vs-td>

              <vs-td :data="data[indextr].balance" :style="{ color: company.balance < 0 ? 'rgb(255, 0, 0)' : company.balance > 0 ? 'rgb(0, 128, 0)' : ''}">
                {{ "R " + Number(company.balance).toLocaleString('en') }}
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
    <div>
      <vx-card id="siteInfoCard" :title="$siteTypeId() == 1 ? 'Classroom Info' : 'Company Info'" v-show="!isInfoHidden">
        <div v-if="formData.id" class="vx-row">
          <div class="vx-col sm:w-2/2 w-full" style="text-align: right; position: absolute;">
            <small class="mr-4"><label>Last modified on <strong>{{ formData.modifiedOn.replace("T", " ").split('.')[0] }}</strong> by <strong>{{ formData.modifiedBy }}</strong></label></small>
          </div>
        </div>

        <div v-if="$siteTypeId() == 1">
          <vs-divider class="mb-6">Classroom Details</vs-divider>
          <div class="vx-row pb-3">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <label>Teacher</label>
              <v-select ref="teacherDropdown" class="w-full" placeholder="Search / Select a Teacher" :options="teachers" v-model="teacherDropdown"></v-select>
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <label>Subject</label>
              <v-select ref="subjectDropdown" class="w-full" placeholder="Search / Select a Subject" :options="subjects" v-model="subjectDropdown"></v-select>
            </div>
          </div>
          <div class="vx-row pb-3">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <label>Name</label>
              <vs-input autocomplete="off" onClick="this.select();" class="w-full" v-validate="'required'" name="Classroom Name" icon-pack="feather" icon="icon-briefcase" icon-no-border v-model="formData.name" />
              <span class="text-danger text-sm" v-show="errors.has('Classroom Name')">{{ errors.first('Classroom Name') }}</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <label>Year</label>
              <datepicker class="w-full" v-model="formData.year" format="yyyy" :minimumView="'year'" :maximumView="'year'"></datepicker>
            </div>
          </div>
          <div class="vx-row pb-3">
            <div class="vx-col w-full mb-2">
              <label>Description</label>
              <vs-textarea class="w-full" v-model="formData.description" />
            </div>
          </div>
        </div>

        <div v-else>
          <vs-divider class="mb-6">Company Details</vs-divider>
          <div class="vx-row pb-3">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <label>Name</label>
              <vs-input autocomplete="off" onClick="this.select();" class="w-full" v-validate="'required'" name="Company Name" icon-pack="feather" icon="icon-briefcase" icon-no-border v-model="formData.name" />
              <span class="text-danger text-sm" v-show="errors.has('Company Name')">{{ errors.first('Company Name') }}</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <label>VAT Number</label>
              <vs-input autocomplete="off" onClick="this.select();" class="w-full" v-validate="'numeric'" name="VAT number" icon-pack="feather" icon="icon-hash" icon-no-border v-model="formData.vatNumber" />
              <span class="text-danger text-sm" v-show="errors.has('VAT number')">{{ errors.first('VAT number') }}</span>
            </div>
          </div>
          <div class="vx-row pb-3">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <label>Registration Number</label>
              <vs-input autocomplete="off" onClick="this.select();" class="w-full" v-validate="{regex: '^[0-9/]+$' }" name="Company Registration" icon-pack="feather" icon="icon-hash" icon-no-border v-model="formData.registrationNumber" />
              <span class="text-danger text-sm" v-show="errors.has('Company Registration')">{{ errors.first('Company Registration') }}</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <label>Work Phone</label>
              <vs-input autocomplete="off" onClick="this.select();" class="w-full" v-validate="'digits:10'" name="Work Number" icon-pack="feather" icon="icon-phone" icon-no-border v-model="formData.workNumber" />
              <span class="text-danger text-sm" v-show="errors.has('Work Number')">{{ errors.first('Work Number') }}</span>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full mb-2">
              <label>Postal Address</label>
              <vs-textarea class="w-full" v-model="formData.postalAddress" />
            </div>
          </div>
          <vs-divider class="mb-6 pt-0">Contact Person</vs-divider>
          <div class="vx-row pb-3">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <label>Name</label>
              <vs-input autocomplete="off" onClick="this.select();" class="w-full" v-validate="'required|alpha_spaces'" name="Contact Name" icon-pack="feather" icon="icon-user" icon-no-border v-model="formData.contactPersonName" />
              <span class="text-danger text-sm" v-show="errors.has('Contact Name')">{{ errors.first('Contact Name') }}</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <label>Email</label>
              <vs-input autocomplete="off" onClick="this.select();" type="email" v-validate="'email'" name="email" class="w-full" icon-pack="feather" icon="icon-at-sign" icon-no-border v-model="formData.contactEmail" />
              <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
            </div>
          </div>
          <div class="vx-row pb-3">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <label>Mobile</label>
              <vs-input autocomplete="off" onClick="this.select();" class="w-full" v-validate="'digits:10'" name="Mobile Number" icon-pack="feather" icon="icon-smartphone" icon-no-border v-model="formData.contactMobile" />
              <span class="text-danger text-sm" v-show="errors.has('Mobile Number')">{{ errors.first('Mobile Number') }}</span>
            </div>
          </div>
        </div>

        <div v-show="formData.id" id="container-of-collapses" style="height: max-content;">
          <!--Unassigned Students-->
          <vs-divider>Unassigned Students</vs-divider>
          <vs-collapse class="border">
            <vs-collapse-item>
              <div slot="header">
                Ready-to-Assign Students
              </div>
              <div>
                <vs-table :sst="true" ref="unassignedStudentsTable" class="vs-con-loading__container" @search="handleUnassignedStudentsSearch" @change-page="handleUnassignedStudentChangePage" stripe single pagination :max-items="unassignedPageSize" search :data="unassignedStudents">
                  <template slot="thead">
                    <vs-th sort-key="userFirstName">Name</vs-th>
                    <vs-th sort-key="mobile">Mobile Number</vs-th>
                    <vs-th sort-key="idNumber">ID Number</vs-th>
                    <vs-th sort-key="email">Email</vs-th>
                    <vs-th>Assign</vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :data="student" :state="student.isActive == false ? 'warning' : null" :key="indextr" v-for="(student, indextr) in data">

                      <vs-td :data="data[indextr].userFirstName">
                        {{ student.userFirstName + " " + student.userLastName }}
                      </vs-td>

                      <vs-td :data="data[indextr].mobile">
                        {{ student.mobile }}
                      </vs-td>

                      <vs-td :data="data[indextr].idNumber">
                        {{ student.idNumber }}
                      </vs-td>

                      <vs-td :data="data[indextr].email">
                        {{ student.email }}
                      </vs-td>

                      <vs-td>
                        <vs-button color="success" type="flat" icon-pack="feather" icon="icon-plus" @click.stop.prevent="assignStudent(student.id)"></vs-button>
                      </vs-td>

                    </vs-tr>
                  </template>
                </vs-table>
              </div>
              <!--<vs-divider></vs-divider>-->
            </vs-collapse-item>
          </vs-collapse>

          <!--Assigned Students-->
          <vs-divider>Assigned Students</vs-divider>
          <vs-collapse class="border">
            <vs-collapse-item>
              <div slot="header">
                Already Assigned Students
              </div>
              <div>
                <vs-table :sst="true" ref="assignedStudentsTable" @search="handleAssignedStudentsSearch" @change-page="handleAssignedStudentChangePage" class="vs-con-loading__container" stripe single pagination :max-items="assignedPageSize" search :data="assignedStudents">
                  <!--<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
              <div class="p-3 mr-4 flex items-center justify-between font-medium text-base">
                <h3 class="ml-2">Already Assigned</h3>
              </div>
            </div>-->
                  <template slot="thead">
                    <vs-th sort-key="studentFullName">Name</vs-th>
                    <vs-th sort-key="studentMobile">Mobile Number</vs-th>
                    <vs-th sort-key="studentIdNumber">ID Number</vs-th>
                    <vs-th sort-key="studentEmail">Email Address</vs-th>
                    <vs-th></vs-th>
                    <vs-th></vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :data="student" :state="assignedStudents.isActive == false ? 'warning' : null" :key="indextr" v-for="(student, indextr) in data">

                      <vs-td :data="data[indextr].userFirstName">
                        {{ student.userFirstName + " " + student.userLastName }}
                      </vs-td>

                      <vs-td :data="data[indextr].mobile">
                        {{ student.mobile }}
                      </vs-td>

                      <vs-td :data="data[indextr].idNumber">
                        {{ student.idNumber }}
                      </vs-td>

                      <vs-td :data="data[indextr].email">
                        {{ student.email }}
                      </vs-td>

                      <vs-td>
                        <vs-button color="success" type="border" size="small" @click.stop.prevent="showTransactionsPopup(student)">View Transactions</vs-button>
                      </vs-td>

                      <vs-td>
                        <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-x" @click.stop.prevent="unassignStudent(student.id)"></vs-button>
                      </vs-td>

                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </vs-collapse-item>
          </vs-collapse>

          <!--Modules-->
          <vs-divider>Modules</vs-divider>
          <vs-collapse class="border">
            <vs-collapse-item id="moduleCollapse">
              <div slot="header">
                Modules
              </div>
              <div style="overflow: auto;">
                <v-select ref="modulesDropdown" placeholder="Search / Select Module to Assign" @search:blur="assignModule" :options="unassignedModules" v-model="modulesDropdown"></v-select>
                <vs-table :sst="true" ref="modulesTable" class="vs-con-loading__container" @search="handleAssignedModulesSearch" @change-page="handleAssignedModulesChangePage" stripe single pagination :max-items="assignedModulesPageSize" search :data="assignedModules">
                  <template slot="thead">
                    <vs-th sort-key="courseName">Course</vs-th>
                    <vs-th sort-key="moduleName">Module</vs-th>
                    <vs-th></vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :data="assignedModules" :key="indextr" v-for="(mod, indextr) in data">

                      <vs-td :data="data[indextr].courseName">
                        {{ mod.courseName }}
                      </vs-td>

                      <vs-td :data="data[indextr].moduleName">
                        {{ mod.moduleName }}
                      </vs-td>

                      <vs-td>
                        <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-x" @click.stop.prevent="areYouSure(mod.moduleId)"></vs-button>
                      </vs-td>

                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </vs-collapse-item>
          </vs-collapse>
        </div>

        <div v-if="$acl.check('MaintainUsers')">
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-divider>Assessors</vs-divider>
            </div>
          </div>
          <vs-collapse class="border">
            <vs-collapse-item :disabled="!assessors">
              <div slot="header">
                View Assigned/Ready-to-Assign Assessors
              </div>
              <div>
                <vs-table ref="assessorsTable" class="vs-con-loading__container" stripe single pagination max-items="10" search :data="assessors">
                  <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                    <div class="pl-3 pb-3 mr-4 flex items-center justify-between font-medium text-base">
                      <h3 class="ml-2">Ready-to-Assign</h3>
                    </div>
                  </div>
                  <template slot="thead">
                    <vs-th sort-key="userFirstName">Name</vs-th>
                    <vs-th sort-key="userLastName">Surname</vs-th>
                    <vs-th></vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :data="assessors" :key="indextr" v-for="(assessor, indextr) in data">

                      <vs-td :data="data[indextr].userFirstName">
                        {{ assessor.userFirstName }}
                      </vs-td>

                      <vs-td :data="data[indextr].userLastName">
                        {{ assessor.userLastName }}
                      </vs-td>

                      <vs-td>
                        <vs-button color="success" type="flat" icon-pack="feather" icon="icon-plus" @click.stop.prevent="assignAssessor(assessor.id)"></vs-button>
                      </vs-td>

                    </vs-tr>
                  </template>
                </vs-table>
              </div>
              <vs-divider></vs-divider>
              <div>
                <vs-table ref="assignedAssessorsTable" class="vs-con-loading__container" stripe single pagination max-items="10" search :data="assignedAssessors">
                  <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                    <div class="p-3 mr-4 flex items-center justify-between font-medium text-base">
                      <h3 class="ml-2">Already Assigned</h3>
                    </div>
                  </div>
                  <template slot="thead">
                    <vs-th sort-key="firstName">Name</vs-th>
                    <vs-th sort-key="lastName">Surname</vs-th>
                    <vs-th></vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :data="assessors" :key="indextr" v-for="(assessor, indextr) in data">

                      <vs-td :data="data[indextr].firstName">
                        {{ assessor.firstName }}
                      </vs-td>

                      <vs-td :data="data[indextr].lastName">
                        {{ assessor.lastName }}
                      </vs-td>

                      <vs-td>
                        <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-x" @click.stop.prevent="unassignAssessor(assessor.userId)"></vs-button>
                      </vs-td>

                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </vs-collapse-item>
          </vs-collapse>
        </div>
        <div v-if="$acl.check('MaintainUsers')">
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-divider>Moderators</vs-divider>
            </div>
          </div>
          <vs-collapse class="border">
            <vs-collapse-item :disabled="!moderators">
              <div slot="header">
                View Assigned/Ready-to-Assign Moderators
              </div>
              <div>
                <vs-table ref="moderatorsTable" class="vs-con-loading__container" stripe single pagination max-items="10" search :data="moderators">
                  <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                    <div class="pl-3 pb-3 mr-4 flex items-center justify-between font-medium text-base">
                      <h3 class="ml-2">Ready-to-Assign</h3>
                    </div>
                  </div>
                  <template slot="thead">
                    <vs-th sort-key="userFirstName">Name</vs-th>
                    <vs-th sort-key="userLastName">Surname</vs-th>
                    <vs-th></vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :data="moderators" :key="indextr" v-for="(moderator, indextr) in data">

                      <vs-td :data="data[indextr].userFirstName">
                        {{ moderator.userFirstName }}
                      </vs-td>

                      <vs-td :data="data[indextr].userLastName">
                        {{ moderator.userLastName }}
                      </vs-td>

                      <vs-td>
                        <vs-button color="success" type="flat" icon-pack="feather" icon="icon-plus" @click.stop.prevent="assignModerator(moderator.id)"></vs-button>
                      </vs-td>

                    </vs-tr>
                  </template>
                </vs-table>
              </div>
              <vs-divider></vs-divider>
              <div>
                <vs-table ref="assignedModeratorsTable" class="vs-con-loading__container" stripe single pagination max-items="10" search :data="assignedModerators">
                  <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                    <div class="p-3 mr-4 flex items-center justify-between font-medium text-base">
                      <h3 class="ml-2">Already Assigned</h3>
                    </div>
                  </div>
                  <template slot="thead">
                    <vs-th sort-key="firstName">Name</vs-th>
                    <vs-th sort-key="lastName">Surname</vs-th>
                    <vs-th></vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :data="moderators" :key="indextr" v-for="(moderator, indextr) in data">

                      <vs-td :data="data[indextr].firstName">
                        {{ moderator.firstName }}
                      </vs-td>

                      <vs-td :data="data[indextr].lastName">
                        {{ moderator.lastName }}
                      </vs-td>

                      <vs-td>
                        <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-x" @click.stop.prevent="unassignModerator(moderator.userId)"></vs-button>
                      </vs-td>

                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </vs-collapse-item>
          </vs-collapse>
        </div>

        <div v-if="$acl.check('MaintainUsers')">
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-divider>Evaluators</vs-divider>
            </div>
          </div>
          <vs-collapse class="border">
            <vs-collapse-item :disabled="!evaluators">
              <div slot="header">
                View Assigned/Ready-to-Assign Evaluators
              </div>
              <div>
                <vs-table ref="evaluatorsTable" class="vs-con-loading__container" stripe single pagination max-items="10" search :data="evaluators">
                  <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                    <div class="pl-3 pb-3 mr-4 flex items-center justify-between font-medium text-base">
                      <h3 class="ml-2">Ready-to-Assign</h3>
                    </div>
                  </div>
                  <template slot="thead">
                    <vs-th sort-key="userFirstName">Name</vs-th>
                    <vs-th sort-key="userLastName">Surname</vs-th>
                    <vs-th></vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :data="evaluators" :key="indextr" v-for="(evaluator, indextr) in data">

                      <vs-td :data="data[indextr].userFirstName">
                        {{ evaluator.userFirstName }}
                      </vs-td>

                      <vs-td :data="data[indextr].userLastName">
                        {{ evaluator.userLastName }}
                      </vs-td>

                      <vs-td>
                        <vs-button color="success" type="flat" icon-pack="feather" icon="icon-plus" @click.stop.prevent="assignEvaluator(evaluator.id)"></vs-button>
                      </vs-td>

                    </vs-tr>
                  </template>
                </vs-table>
              </div>
              <vs-divider></vs-divider>
              <div>
                <vs-table ref="assignedEvaluatorsTable" class="vs-con-loading__container" stripe single pagination max-items="10" search :data="assignedEvaluators">
                  <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                    <div class="p-3 mr-4 flex items-center justify-between font-medium text-base">
                      <h3 class="ml-2">Already Assigned</h3>
                    </div>
                  </div>
                  <template slot="thead">
                    <vs-th sort-key="firstName">Name</vs-th>
                    <vs-th sort-key="lastName">Surname</vs-th>
                    <vs-th></vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :data="evaluators" :key="indextr" v-for="(evaluator, indextr) in data">

                      <vs-td :data="data[indextr].firstName">
                        {{ evaluator.firstName }}
                      </vs-td>

                      <vs-td :data="data[indextr].lastName">
                        {{ evaluator.lastName }}
                      </vs-td>

                      <vs-td>
                        <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-x" @click.stop.prevent="unassignEvaluator(evaluator.userId)"></vs-button>
                      </vs-td>

                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </vs-collapse-item>
          </vs-collapse>
        </div>

        <div v-if="$acl.check('MaintainUsers')">
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-divider>Mentors</vs-divider>
            </div>
          </div>
          <vs-collapse class="border">
            <vs-collapse-item :disabled="!mentors">
              <div slot="header">
                View Assigned/Ready-to-Assign Mentors
              </div>
              <div>
                <vs-table ref="mentorTable" class="vs-con-loading__container" stripe single pagination max-items="10" search :data="mentors">
                  <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                    <div class="pl-3 pb-3 mr-4 flex items-center justify-between font-medium text-base">
                      <h3 class="ml-2">Ready-to-Assign</h3>
                    </div>
                  </div>
                  <template slot="thead">
                    <vs-th sort-key="userFirstName">Name</vs-th>
                    <vs-th sort-key="userLastName">Surname</vs-th>
                    <vs-th></vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :data="mentors" :key="indextr" v-for="(mentor, indextr) in data">

                      <vs-td :data="data[indextr].userFirstName">
                        {{ mentor.userFirstName }}
                      </vs-td>

                      <vs-td :data="data[indextr].userLastName">
                        {{ mentor.userLastName }}
                      </vs-td>

                      <vs-td>
                        <vs-button color="success" type="flat" icon-pack="feather" icon="icon-plus" @click.stop.prevent="assignMentor(mentor.id)"></vs-button>
                      </vs-td>

                    </vs-tr>
                  </template>
                </vs-table>
              </div>
              <vs-divider></vs-divider>
              <div>
                <vs-table ref="assignedMentorTable" class="vs-con-loading__container" stripe single pagination max-items="10" search :data="assignedMentors">
                  <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                    <div class="p-3 mr-4 flex items-center justify-between font-medium text-base">
                      <h3 class="ml-2">Already Assigned</h3>
                    </div>
                  </div>
                  <template slot="thead">
                    <vs-th sort-key="firstName">Name</vs-th>
                    <vs-th sort-key="lastName">Surname</vs-th>
                    <vs-th></vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :data="mentors" :key="indextr" v-for="(mentor, indextr) in data">

                      <vs-td :data="data[indextr].firstName">
                        {{ mentor.firstName }}
                      </vs-td>

                      <vs-td :data="data[indextr].lastName">
                        {{ mentor.lastName }}
                      </vs-td>

                      <vs-td>
                        <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-x" @click.stop.prevent="unassignMentor(mentor.userId)"></vs-button>
                      </vs-td>

                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </vs-collapse-item>
          </vs-collapse>
        </div>

        <div v-if="$acl.check('MaintainUsers')">
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-divider>Logbook</vs-divider>
            </div>
          </div>
          <vs-collapse class="border">
            <vs-collapse-item :disabled="!mentors">
              <div slot="header">
                Logbook Options
              </div>
              <div class="vx-row w-full">
                <div class="vx-col w-1/2">
                  <label>Select Mentor</label>
                  <v-select class="w-full" ref="assessorDropdown" placeholder="Search / Select Mentor to Sign Logbooks" :options="assignedMentorsDropDown" v-model="selectedMentor"></v-select>
                </div>
                <div class="vx-col w-1/2 mb-2">
                  <label>Mentor Note</label>
                  <vs-textarea class="w-full" v-model="mentorNote" />
                </div>
              </div>
              <div class="vx-row w-full">
                <div class="vx-col w-1/2">
                  <vs-button :disabled="!selectedMentor || mentorNote == ''" color="success" class="float-left mr-2" @click="queueLogbooks">Queue Logbooks</vs-button>
                </div>
              </div>
            </vs-collapse-item>
          </vs-collapse>
        </div>

        <div v-if="$acl.check('MaintainUsers') && $siteTypeId() != 1">
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-divider>Monitor</vs-divider>
            </div>
          </div>
          <vs-collapse class="border">
            <vs-collapse-item :disabled="!monitorsLoaded">
              <div slot="header">
                View Assigned/Ready-to-Assign Monitor
              </div>
              <div>
                <vs-table ref="notAssignMonitorsTable" class="vs-con-loading__container" stripe single pagination max-items="10" search :data="notAssignMonitors">
                  <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                    <div class="pl-3 pb-3 mr-4 flex items-center justify-between font-medium text-base">
                      <h3 class="ml-2">Ready-to-Assign</h3>
                    </div>
                  </div>
                  <template slot="thead">
                    <vs-th sort-key="firstName">Name</vs-th>
                    <vs-th sort-key="lastName">Surname</vs-th>
                    <vs-th></vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :data="monitor" :key="indextr" v-for="(monitor, indextr) in data">

                      <vs-td :data="data[indextr].firstName">
                        {{ monitor.firstName }}
                      </vs-td>

                      <vs-td :data="data[indextr].lastName">
                        {{ monitor.lastName }}
                      </vs-td>

                      <vs-td>
                        <vs-button color="success" type="flat" icon-pack="feather" icon="icon-plus" @click.stop.prevent="assignMonitor(monitor.userId)"></vs-button>
                      </vs-td>

                    </vs-tr>
                  </template>
                </vs-table>
              </div>
              <vs-divider></vs-divider>
              <div>
                <vs-table ref="assignedMonitorsTable" class="vs-con-loading__container" stripe single pagination max-items="10" search :data="assignMonitors">
                  <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                    <div class="p-3 mr-4 flex items-center justify-between font-medium text-base">
                      <h3 class="ml-2">Already Assigned</h3>
                    </div>
                  </div>
                  <template slot="thead">
                    <vs-th sort-key="firstName">Name</vs-th>
                    <vs-th sort-key="lastName">Surname</vs-th>
                    <vs-th></vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :data="monitor" :key="indextr" v-for="(monitor, indextr) in data">

                      <vs-td :data="data[indextr].firstName">
                        {{ monitor.firstName }}
                      </vs-td>

                      <vs-td :data="data[indextr].lastName">
                        {{ monitor.lastName }}
                      </vs-td>

                      <vs-td>
                        <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-x" @click.stop.prevent="unassignMonitor(monitor.userId)"></vs-button>
                      </vs-td>

                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </vs-collapse-item>
          </vs-collapse>
        </div>

        <div v-if="$acl.check('MaintainUsers') && $siteTypeId() != 1">
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-divider>Bulk Assign</vs-divider>
            </div>
          </div>
          <vs-collapse class="border">
            <vs-collapse-item>
              
              <div slot="header">
                Bulk Assign Assessors to Students
              </div>
              <vs-button type="border"  class="mb-3 " @click="downloadTemplateBulkAssing">Get Template</vs-button>

              <div>
                <file-pond
                    id="fileUpload"
                    ref="pond"
                    accepted-file-types="text/csv" 
                    label-idle="Upload csv file here"
                    :server="uploadLocation"
                    :name="'file'"
                    :preview="false"
                    :allow-multiple="false"
                    :allow-image-preview="false"
                    :instant-upload="true"
                    @processfile="uploadComplete"
                    @removefile="fileRemoved"
                  />
              </div>
            </vs-collapse-item>
          </vs-collapse>
        </div>

        <vs-divider></vs-divider>

        <div class="vx-row">
          <div class="vx-col" v-show="formData.id">
            <vs-button v-show="isBulkAddHidden" color="success" type="border" class="mr-3 mb-2 vs-con-loading__container" @click.prevent="bulkStudentAdd" ref="bulkAddButton">Bulk Student Add</vs-button>
            <div class="flex flex-wrap items-center justify-center">
              <div class="vs-con-loading__container">
                <v-uploader v-show="!isBulkAddHidden && !bulkCsvFileUrl && $siteTypeId() == 1" @done="csvSuccessUpload" ref="bulkUpload" file-type-exts="csv" button-text="Upload .csv" language="en" file-size-limit="100MB" :preview="false"></v-uploader>
              </div>
              <vs-button v-show="bulkCsvFileUrl" ref="confirmBulkButton" color="success" size="small" class="mb-4 mr-3" @click="confirmBulkStudentAdd">Add Students</vs-button>
              <vs-button v-show="!isBulkAddHidden" :disabled="!canCancel" type="border" size="small" class="mb-4 ml-3" @click="downloadTemplate">Get Template</vs-button>
              <vs-button v-show="!isBulkAddHidden" :disabled="!canCancel" color="warning" size="small" class="mb-4 ml-3" @click="cancelBulkAdd">Cancel</vs-button>
              
            </div>
          </div>
          <vs-spacer></vs-spacer>
          <div class="vx-col">
            <vs-button color="success" class="mr-3 mb-2 vs-con-loading__container" @click.prevent="saveEditCompany" ref="saveEditButton">Save</vs-button>
            <vs-button color="danger" class="mr-3 vs-con-loading__container cursor-pointer" v-show="formData.id" @click="deletePopupActive=true" ref="deleteButton">Delete</vs-button>
            <vs-button color="warning" type="border" class="mb-2" v-scroll-to="'#siteInfoCard'" @click="cancelAdd">Cancel</vs-button>
          </div>
        </div>
      </vx-card>
    </div>


    <vs-popup id="bulkNotAddedPopup" title="Information of Students NOT Added" class="vs-con-loading__container" :active.sync="bulkNotAddedPopupActive">
      <div v-if="bulkAddResponse && bulkAddResponse.totalNotAdded != 0">
        <table id="bulkResponseTable" style="width: 100%;">
          <tr>
            <th>Row no.</th>
            <th>Name</th>
            <th>Email</th>
            <th>Reason</th>
          </tr>
          <tr class="ml-0" v-for="(item, index) in bulkAddResponse.studentsNotAdded" :key="index">
            <td>
              {{ item.rowNumber }}
            </td>
            <td>
              {{ item.firstname }} {{ item.lastname }}
            </td>
            <td>
              {{ item.email }}
            </td>
            <td>
              {{ item.message }}
            </td>
          </tr>
        </table>

        <div class="vx-row">
          <vs-spacer></vs-spacer>
          <div class="vx-col" style="display: flex;">
            <vs-button class="mt-4" icon-pack="feather" icon="icon-copy" @click="selectElementContents('bulkResponseTable')">Copy to Clipboard</vs-button>
            <vs-button class="mt-4 ml-4" color="success" icon-pack="feather" icon="icon-download" @click="exportBulkToExcel">Download .csv</vs-button>
          </div>
        </div>
      </div>
    </vs-popup>

    <vs-popup id="transactionsPopup" ref="transactionsPopup" :title="`${'Transactions for'} ${selectedStudent.name}`" :active.sync="transactionsPopupActive">
      <div v-if="selectedStudent && selectedStudent.transactions.length > 0">
        <table id="transactionTable" style="width: 100%;">
          <tr>
            <th>Reason</th>
            <th>Amount</th>
            <th>Date</th>
          </tr>
          <tr class="ml-0" v-for="(item, index) in selectedStudent.transactions" :key="index">
            <td>
              {{ item.transactionType }}
            </td>
            <td :style="{ color: item.amount < 0 ? 'rgb(255, 0, 0)' : item.amount > 0 ? 'rgb(0, 128, 0)' : ''}">
              {{ "R " + Number(item.amount).toLocaleString('en') }}
            </td>
            <td>
              {{ item.createdOn.replace("T", " ").split('.')[0] }}
            </td>
          </tr>
        </table>

        <div class="vx-row">
          <vs-spacer></vs-spacer>
          <div class="vx-col" style="display: flex;">
            <vs-button class="mt-4" icon-pack="feather" icon="icon-copy" @click="selectElementContents('transactionTable')">Copy to Clipboard</vs-button>
            <vs-button class="mt-4 ml-4" color="success" icon-pack="feather" icon="icon-download" @click="exportTransactionsToExcel">Download .csv</vs-button>
          </div>
        </div>
      </div>
      <div v-else>
        <p style="text-align-last: center;">No transactions yet...</p>
      </div>
    </vs-popup>

    <vs-popup title="Are you sure?" :active.sync="deletePopupActive">
      <p class="pb-2">This will unassign all users and modules</p>
      <div class="mt-3">
        <vs-button color="warning" class="float-right" @click="cancelDeleteCompany">Cancel</vs-button>
        <vs-button color="success" class="float-right mr-2" @click="deleteCompany">Submit</vs-button>
      </div>
    </vs-popup>

    <vs-popup title="Upload Feedback" :active.sync="showBulkStudentValidation">
      <vs-table ref="premiumList" stripe class="vs-con-loading__container" single pagination :max-items="tasksPerPage" search :data="bulkUploadRows">
        <div slot="header" class="vx-row flex flex-wrap-reverse items-center flex-grow">
          <!-- ITEMS PER PAGE -->
          <div class="vx-row w-full">
            <div style="margin-left: 20px;" class="vx-col w-full">
              <vs-dropdown  vs-trigger-click class="cursor-pointer mb-4 mr-4 vx-col s:w-1/2 xs:w-full sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2">
                <div class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium" >
                  <span class="mr-2">{{ currentTaskPage * tasksPerPage - (tasksPerPage - 1) }} - {{ bulkUploadRows.length - currentTaskPage * tasksPerPage > 0 ? currentTaskPage * tasksPerPage : bulkUploadRows.length }} of {{ bulkUploadRows.length }}</span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/> 
                </div>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="tasksPerPage=10">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="tasksPerPage=15">
                    <span>15</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="tasksPerPage=20">
                    <span>20</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="tasksPerPage=25">
                    <span>25</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="tasksPerPage=50">
                    <span>50</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="tasksPerPage=100">
                    <span>100</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
            <div style="margin-left: 20px;" class="vx-col w-full">
              <h4>{{`Amount Of Errors: ${errorAtLines.length}/${bulkUploadRows.length}`}}</h4>
            </div>
          </div>
        </div>
      
        <template slot="thead">
          <vs-th sort-key="error">Row</vs-th>
          <vs-th sort-key="error">Data</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr :state="row.error ? 'danger' : 'success'" :data="row" :key="indextr" v-for="(row, indextr) in data"> 
 
            <vs-td :data="data[indextr]">
             {{ row.index }}
           </vs-td> 

           <vs-td :data="data[indextr]">
             {{ row.row }}
           </vs-td> 
      
          </vs-tr>
        </template>
      </vs-table>
      <div class="mt-3">
        <vs-button color="warning" class="float-right" @click="cancelBulkUpload">Cancel</vs-button>
        <vs-button :disabled="bulkUploadRows.some(x=>x.error)"  color="success" class="float-right mr-2" @click="UploadCSVAssign">Submit</vs-button>
      </div>
    </vs-popup>


    <vs-popup ref="bulkStudentUploadPopupUploadFile" id="bulkStudentUploadPopupUploadFile" title="Bulk Student Add" class="vs-con-loading__container" :active.sync="uploadBulkStudentAddFile">
      <div class="vx-row">
        <div class="vx-col w-full">
          <file-pond
          id="cover-filepond"
          ref="pond2"
          accepted-file-types="text/csv,application/vnd.ms-excel" 
          label-idle="Upload CSV file here"
          :server="uploadLocation"
          :preview="false"
          :allow-multiple="false"
          :allow-image-preview="false"
          :instant-upload="true"
          @processfile="uploadCompleteForBulkStudentAdd"
          @removefile="fileRemoved"
        />
        </div>
      </div>
      <div class="vx-row">
        <vs-button type="border" size="small" class="mb-4 ml-3" @click="downloadTemplate">Get Template</vs-button>
      </div>
    </vs-popup>

    <vs-popup class="uploadFeedback" title="Upload Feedback" :active.sync="showBulkStudentAddValidation">
      <div class="vx-col w-full">
        <h4>{{`Students To Add: ${bulkAddStudentUploadRows.length}`}}</h4>
        <h4>{{`Amount Of Errors: ${errorAtLines.length}/${bulkAddStudentUploadRows.length}`}}</h4>
      </div>
      <vs-table ref="premiumList" stripe class="vs-con-loading__container" single pagination :max-items="tasksPerPage" search :data="bulkAddStudentUploadRows">
        <div slot="header" class="vx-row flex flex-wrap-reverse items-center flex-grow">
          <!-- ITEMS PER PAGE -->
          <div class="vx-row w-full">
            <div style="margin-left: 20px;" class="vx-col w-full">
              <vs-dropdown  vs-trigger-click class="cursor-pointer mb-4 mr-4 vx-col s:w-1/2 xs:w-full sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2">
                <div class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium" >
                  <span class="mr-2">{{ currentTaskPage * tasksPerPage - (tasksPerPage - 1) }} - {{ bulkAddStudentUploadRows.length - currentTaskPage * tasksPerPage > 0 ? currentTaskPage * tasksPerPage : bulkAddStudentUploadRows.length }} of {{ bulkAddStudentUploadRows.length }}</span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/> 
                </div>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="tasksPerPage=10">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="tasksPerPage=15">
                    <span>15</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="tasksPerPage=20">
                    <span>20</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="tasksPerPage=25">
                    <span>25</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="tasksPerPage=50">
                    <span>50</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="tasksPerPage=100">
                    <span>100</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </div>
        </div>
      
        <template slot="thead">
          <vs-th sort-key="error">Row</vs-th>
          <vs-th sort-key="lastName">Last Name</vs-th>
          <vs-th sort-key="firstName">First Name</vs-th>
          <vs-th sort-key="work">Work</vs-th>
          <vs-th sort-key="mobile">Mobile</vs-th>
          <vs-th sort-key="password">Password</vs-th>
          <vs-th sort-key="idNumber">Id Number</vs-th>
          <vs-th sort-key="error">Error</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr :state="row.error ? 'danger' : 'success'" :data="row" :key="indextr" v-for="(row, indextr) in data"> 
 
            <vs-td :data="data[indextr]">
             {{ row.index }}
           </vs-td> 

           <vs-td :data="data[indextr]">
             {{ row.lastName }}
           </vs-td> 

           <vs-td :data="data[indextr]">
             {{ row.firstName }}
           </vs-td> 

           <vs-td :data="data[indextr]">
             {{ row.work }}
           </vs-td> 
           
           <vs-td :data="data[indextr]">
             {{ row.mobile }}
           </vs-td> 

           <vs-td :data="data[indextr]">
             {{ row.password }}
           </vs-td>

           <vs-td :data="data[indextr]">
             {{ row.idNumber }}
           </vs-td>

           <vs-td :data="data[indextr]">
             {{ row.error }}
           </vs-td>

          </vs-tr>
        </template>
      </vs-table>
      <div class="mt-3">
        <vs-button color="warning" class="float-right" @click="cancelBulkStudentAddValidation">Cancel</vs-button>
        <vs-button :disabled="bulkAddStudentUploadRows.some(x=>x.error)"  color="success" class="float-right mr-2" @click="uploadBulkStudentCSV">Submit</vs-button>
      </div>
    </vs-popup>

  </div>
</template>

<script>
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker';

import vueFilePond, {setOptions } from 'vue-filepond';
  import FilePondPluginFileRename from 'filepond-plugin-file-rename';
  import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
  import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
  const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview,FilePondPluginFileRename);


  setOptions({
    fileRenameFunction: (file) => {
      var siteName = "Temp";
      if(localStorage.getItem('userSiteInfo') != ""){
        if(JSON.parse(localStorage.getItem('userSiteInfo')) instanceof Array)
          siteName = JSON.parse(localStorage.getItem('userSiteInfo'))[0].name;
        else 
          siteName = JSON.parse(localStorage.getItem('userSiteInfo')).name;
      }
        var randomString = Date.now();
        var dateObj = new Date();
        var year = dateObj.getUTCFullYear();
        var month = (dateObj.getUTCMonth() + 1).toString();
        var newBaseName = file.basename.replaceAll('#','');
        return siteName + "_Auto~BulkStudentAssign~" + year + "_" +  "00".substring(0, 2 - month.length) + month + "~" + newBaseName + "_" + randomString + file.extension;
    }
  });

export default {
  components: {
    vSelect,
    Datepicker
  },
  data() {
    return {
      headerTitleBulk: ["RowNumber","Firstname","Lastname","Email","Message"],
      headerValBulk: ["rowNumber","firstname","lastname","email","message"],
      headerTitleTrans: ["Reason","Amount","Date"],
      headerValTrans: ["transactionType","amount","createdOn"],
      bulkNotAddedPopupActive: false,
      transactionsPopupActive: false,
      studentsNotAdded: "",
      bulkCsvFileUrl: "",
      canCancel: true,
      isLoading: false,
      isBulkAddHidden: true,
      uploadBulkStudentAddFile:false,
      loadingColor: "#fff",
      selected: [],
      isInfoHidden: true,
      isCompanyListHidden: false,
      companies: [],
      formData: {
        id: 0,
        name: "",
        vatNumber: "",
        registrationNumber: "",
        postalAddress: "",
        contactPersonName: "",
        workNumber: "",
        contactMobile: "",
        contactEmail: "",
        modifiedOn: "",
        modifiedBy: "",
        description: null,
        teacherId: null,
        courseId: null,
        year: null
      },
      bulkAddResponse: {},
      unassignedStudents: [],
      assignedStudents: [],
      selectedStudent: {
        id: 0,
        name: "",
        transactions: []
      },
      criteria:{
        unassignedPageNumber : 0,
        unassignedPageSize: 0,
        unassignedSearchPhrase: "",
        assignedPageNumber: 0,
        assignedPageSize: 0,
        assignedSearchPhrase: "",
        assignedModulesPageNumber: 0,
        assignedModulesPageSize: 0,
        assignedModulesSearchPhrase: ""
      },
      unassignedPageSize: 10,
      assignedPageSize: 10,
      teachers: [],
      teacherDropdown: 0,
      subjects: [],
      subjectDropdown: 0,
      currentUserId: null,
      assignedModulesPageSize: 10,
      modulesDropdown: 0,
      unassignedModules: [],
      assignedModules: [],
      assessors: [],
      showInactiveAssessors: false,
      assignedAssessors: [],
      moderators: [],
      showInactiveModerators: false,
      assignedModerators: [],
      evaluators: [],
      mentors: [],
      showInactiveEvaluators: false,
      assignedEvaluators: [],
      assignedMentors: [],
      unassignedMentors: [],
      mentorsDropdown: 0,
      showInactiveMentors: false,
      deletePopupActive: false,
      companyAssignModule: {
        companyId: 0,
        moduleId: 0
      },
      assignedMentorsDropDown:[],
      selectedMentor:null,
      mentorNote:'',
      assignMonitors:[],
      notAssignMonitors:[],
      monitorsLoaded:false,
      bulkCsvFileAssignUrl:"",
      bulkCsvStudentAssignUrl:"",
      errorAtLines:[],
      bulkUploadRows:[],
      bulkAddStudentUploadRows:[],
      showBulkStudentValidation:false,
      tasksPerPage:10,
      currentTaskPage:1,
      showBulkStudentAddValidation:false
    };
  },
  computed:{
    server(){
      return {
        url: 'https://content.digicampus.co.za/scripts/',
        process: {
          url: 'tue4VGmEsLhfsy43X8WBemZ5UnTzLDuD2.php',
        },
      };
    },
    uploadLocation: {
        get() {
          return this.$buildUrl("tempupload");
        }
      },
  },
  methods: {
    getTeachers() {
      var self = this;

      var onSuccess = response => {
        self.teachers = response.data.map((item) => {return {label: item.text, value: item.value} });
      };
      
      self.$ajaxGet(self, "user/GetTeachers", onSuccess);
    },
    cancelDeleteCompany(){
      this.deletePopupActive = false;
    },
    getSubjects() {
      var self = this;

      var onSuccess = response => {
        self.subjects = response.data.map((item) => {return {label: item.text, value: item.value} });
      };
      
      self.$ajaxGet(self, "Course/GetSelectList", onSuccess);
    },
    selectElementContents(elId) {
      var el = document.getElementById(elId);
      var body = document.body, range, sel;
      if (document.createRange && window.getSelection) {
        range = document.createRange();
        sel = window.getSelection();
        sel.removeAllRanges();
        try {
          range.selectNodeContents(el);
          sel.addRange(range);
        } catch (e) {
          range.selectNode(el);
          sel.addRange(range);
        }
        document.execCommand("copy");
        this.$vs.notify({
          color: "success",
          text: "Copied!",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-clipboard"
        });
      } else if (body.createTextRange) {
        range = body.createTextRange();
        range.moveToElementText(el);
        range.select();
        range.execCommand("Copy");
        this.$vs.notify({
          color: "success",
          text: "Copied!",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-clipboard"
        });
      }
      sel.removeAllRanges();
    },
    exportBulkToExcel() {
      var self = this;
      import('@/vendor/Export2Excel').then(excel => {
        const list = self.bulkAddResponse.studentsNotAdded;
        const data = self.formatJson(self.headerValBulk, list)
        excel.export_json_to_excel({
          header: self.headerTitleBulk,
          data,
          filename: `${self.bulkAddResponse.totalNotAdded}_students_not_added_for_site_${self.formData.companyName}`,
          autoWidth: false,
          bookType: "csv"
        })
      })
    },
    exportTransactionsToExcel() {
      var self = this;
      import('@/vendor/Export2Excel').then(excel => {
        const list = self.selectedStudent.transactions;
        const data = self.formatJson(self.headerValTrans, list);
        var date = new Date();
        excel.export_json_to_excel({
          header: self.headerTitleTrans,
          data,
          filename: `Transactions for ${self.selectedStudent.name} (${date.getDate()}-${date.getMonth()}-${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()})`,
          autoWidth: false,
          bookType: "csv"
        })
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        return v[j]
      }))
    },
    initValues() {
      this.formData.id = 0;
      this.formData.name = "";
      this.formData.vatNumber = "";
      this.formData.registrationNumber = "";
      this.formData.postalAddress = "";
      this.formData.contactPersonName = "";
      this.formData.workNumber = "";
      this.formData.contactMobile = "";
      this.formData.contactEmail = "";
      this.formData.modifiedOn = "";
      this.formData.modifiedBy = "";
      this.formData.description = null;
      this.formData.teacherId = null;
      this.formData.courseId = null;
      this.formData.year = new Date();
      this.isLoading = false;
      this.bulkCsvFileUrl = "";
      this.canCancel = true;
      this.unassignedStudents = [];
      this.assignedStudents = [];

      this.assignedModules = [];

      this.selectedStudent.id = 0;
      this.selectedStudent.name = "";
      this.selectedStudent.transactions = [];

      this.teacherDropdown = 0;
      this.subjectDropdown = 0;
      
      this.criteria.assignedModulesPageSize = 10;
      this.criteria.assignedModulesSearchPhrase = "";
      this.criteria.assignedPageSize = 10;
      this.criteria.assignedSearchPhrase = "";
      this.criteria.unassignedPageSize = 10;
      this.criteria.unassignedSearchPhrase = "";
      this.errors.clear();
      this.mentorNote = '';
      this.assignedMentorsDropDown =[];
      this.selectedMentor =null;
      this.assignMonitors = [];
      this.notAssignMonitors = [];
      this.monitorsLoaded = false;
      this.bulkUploadRows=[];
    },
    cancelAdd() {
      this.initValues();
      this.isInfoHidden = true;
      this.isCompanyListHidden = false;
    },
    deleteCompany(){
      var self = this;
      self.showLoadingOnElement("companyPage", 1, "corners");

      var onSuccess = function (response) {
        self.$vs.notify({
          title: 'Information',
          color: "success",
          text: self.$siteTypeId() == 1 ? 'Classroom deleted': 'Company Deleted',
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-user-check'
        });
        self.deletePopupActive = false;
        self.saveData();
        self.cancelAdd();

      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.companyPage.$el);
      };

      self.$ajaxGet(self, "Company/DeleteCompany?companyId=" + self.formData.id, onSuccess, onFinally);
    },
    addNewCompany() {
      this.errors.clear();
      this.initValues();
      this.isCompanyListHidden = true;
      this.isInfoHidden = false;
      this.addUploaderClickEvents();
    },
    saveData() {
      this.showLoadingOnTable();
      this.loadCompanyData();
      this.$vs.loading.close(this.$refs.saveEditButton.$el);
    },
    loadCompanyData() {
      const self = this;

        var onSuccess = function (response) {
          self.companies = response.data;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.companiesTable.$el);
        };

      self.$ajaxGet(self, "Company/ListCompanies", onSuccess, onFinally);
    },
    handleSelectedCompany(company) {
      this.addUploaderClickEvents();
      this.getUnassignedStudents(company.id);
      this.getAssignedStudents(company.id);
      this.isCompanyListHidden = true;
      this.isInfoHidden = false;
      this.changePassword = false;
      this.formData.id = company.id;
      this.formData.name = company.name;
      this.formData.vatNumber = company.vatNumber;
      this.formData.registrationNumber = company.registrationNumber;
      this.formData.postalAddress = company.postalAddress;
      this.formData.contactPersonName = company.contactPersonName;
      this.formData.workNumber = company.workNumber;
      this.formData.contactMobile = company.contactMobile;
      this.formData.contactEmail = company.contactEmail;
      this.formData.modifiedOn = company.modifiedOn;
      this.formData.modifiedBy = company.modifiedBy;

      this.getModulesDropdownList(company.id);
      this.getAssignedModules(company.id);
      if (this.$siteTypeId() == 1) {
        this.formData.description = company.description;

        if (company.year) {
          this.formData.year = new Date(company.year, 1, 1);
        }
        else {
          this.formData.year = new Date();
        }

        this.teacherDropdown = this.teachers.filter(function (item) { return item.value == company.teacherId; })[0];
        this.subjectDropdown = this.subjects.filter(function (item) { return item.value == company.courseId; })[0];
      } else {

        if (this.$acl.check("MaintainUsers") && this.$siteTypeId() != 1) {
          this.getAllAssessors(this.formData.id);
          this.getAssignedAssessors(false);
          this.getAllModerators(this.formData.id);
          this.getAssignedModerators(false);
          this.getAllEvaluators(this.formData.id);
          this.getAssignedEvaluators(false);
          this.getAllMentors(this.formData.id);
          this.getAssignedMentors(false);
          this.getAssignedAndNotAssignedMonitors();
        }
      }
    },
    getAllMentors(companyId) {
      const self = this;
      self.showLoadingOnElement("mentorTable", 1, "corners");

      var onSuccess = function (response) {
        self.mentors = response.data;
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.mentorTable.$el);
      };

      self.$ajaxGet(self, "Company/GetAllMentors?companyId=" + companyId, onSuccess, onFinally);
    },
    getAssignedMentors(val) {
      const self = this;
      self.showLoadingOnElement("assignedMentorTable", 1, "corners");

      var onSuccess = function (response) {
        self.assignedMentors = response.data;
        self.assignedMentorsDropDown = response.data.map(function(item) {return {value: item.userId,label: `${item.firstName} ${item.lastName}`}})
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.assignedMentorTable.$el);
        self.$refs.assignedMentorTable.searchx = "";
      };

      self.$ajaxGet(self, "Company/ListCompanyAssignedMentors?showInactive=" + val + "&companyId=" + self.formData.id, onSuccess, onFinally);
    },
    assignMentor(userId) {
      var self = this;
      self.showLoadingOnElement("assignedMentorTable", 1, "corners");

      var onSuccess = response => {
        self.$vs.notify({
          title: 'Information',
          color: "success",
          text: `Mentor Assigned to ${self.$siteTypeId() == 1 ? 'Topic' : 'Module'}`,
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-user-check'
        });
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.assignedMentorTable.$el);
        self.getAllMentors(self.formData.id);
        self.getAssignedMentors(self.showInactiveMentors);
      };

      self.$ajaxGet(self, "Company/AssignMentorToCompany?userId=" + userId + "&companyId=" + self.formData.id, onSuccess, onFinally);
    },
    unassignMentor(userId) {
      var self = this;
      self.showLoadingOnElement("assignedMentorTable", 1, "corners");

      var onSuccess = response => {
        self.$vs.notify({
          title: 'Information',
          color: "success",
          text: `Mentor Unassigned from ${self.$siteTypeId() == 1 ? 'Topic' : 'Module'}`,
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-user-minus'
        });
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.assignedMentorTable.$el);
        self.getAllMentors(self.formData.id);
        self.getAssignedMentors(self.showInactiveMentors);
      };

      self.$ajaxGet(self, "Company/RemoveMentorFromCompany?userId=" + userId + "&companyId=" + self.formData.id, onSuccess, onFinally);
    },
    getAllAssessors(companyId) {
      const self = this;
      self.showLoadingOnElement("assessorsTable", 1, "corners");

      var onSuccess = function (response) {
        self.assessors = response.data;
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.assessorsTable.$el);
      };

      self.$ajaxGet(self, "Company/GetAllAssessors?companyId=" + companyId, onSuccess, onFinally);
    },
    getAssignedAssessors(val) {
      const self = this;
      self.showLoadingOnElement("assignedAssessorsTable", 1, "corners");

      var onSuccess = function (response) {
        self.assignedAssessors = response.data;
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.assignedAssessorsTable.$el);
        self.$refs.assignedAssessorsTable.searchx = "";
      };

      self.$ajaxGet(self, "Company/ListCompanyAssignedAssessors?showInactive=" + val + "&companyId=" + self.formData.id, onSuccess, onFinally);
    },
    assignAssessor(userId) {
      var self = this;
      self.showLoadingOnElement("assessorsTable", 1, "corners");

      var onSuccess = response => {
        self.$vs.notify({
          title: 'Information',
          color: "success",
          text: `Assessor Assigned to ${self.$siteTypeId() == 1 ? 'Topic' : 'Module'}`,
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-user-check'
        });
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.assessorsTable.$el);
        self.getAllAssessors(self.formData.id);
        self.getAssignedAssessors(self.showInactiveAssessors);
      };

      self.$ajaxGet(self, "Company/AssignAssessorToCompany?userId=" + userId + "&companyId=" + self.formData.id, onSuccess, onFinally);
    },
    unassignAssessor(userId) {
      var self = this;
      self.showLoadingOnElement("assignedAssessorsTable", 1, "corners");

      var onSuccess = response => {
        self.$vs.notify({
          title: 'Information',
          color: "success",
          text: `Assessor Unassigned from ${self.$siteTypeId() == 1 ? 'Topic' : 'Module'}`,
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-user-minus'
        });
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.assignedAssessorsTable.$el);
        self.getAllAssessors(self.formData.id);
        self.getAssignedAssessors(self.showInactiveAssessors);
      };

      self.$ajaxGet(self, "Company/RemoveAssessorFromCompany?userId=" + userId + "&companyId=" + self.formData.id, onSuccess, onFinally);
    },
    getAllModerators(companyId) {
      const self = this;
      self.showLoadingOnElement("moderatorsTable", 1, "corners");

      var onSuccess = function (response) {
        self.moderators = response.data;
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.moderatorsTable.$el);
        self.$refs.moderatorsTable.searchx = "";
      };

      self.$ajaxGet(self, "Company/GetAllModerators?companyId=" + companyId, onSuccess, onFinally);
    },
    getAllEvaluators(companyId) {
      const self = this;
      self.showLoadingOnElement("evaluatorsTable", 1, "corners");

      var onSuccess = function (response) {
        self.evaluators = response.data;
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.evaluatorsTable.$el);
        self.$refs.evaluatorsTable.searchx = "";
      };

      self.$ajaxGet(self, "Company/GetAllEvaluators?companyId=" + companyId, onSuccess, onFinally);
    },
    getAssignedEvaluators(val) {
      const self = this;
      self.showLoadingOnElement("assignedEvaluatorsTable", 1, "corners");

      var onSuccess = function (response) {
        self.assignedEvaluators = response.data;
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.assignedEvaluatorsTable.$el);
        self.$refs.assignedEvaluatorsTable.searchx = "";
      };

      self.$ajaxGet(self, "Company/ListCompanyAssignedEvaluators?showInactive=" + val + "&companyId=" + self.formData.id, onSuccess, onFinally);
    },
    assignEvaluator(userId) {
      var self = this;
      self.showLoadingOnElement("evaluatorsTable", 1, "corners");

      var onSuccess = response => {
        self.$vs.notify({
          title: 'Information',
          color: "success",
          text: `Evaluator Assigned to ${self.$siteTypeId() == 1 ? 'Topic' : 'Module'}`,
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-user-check'
        });
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.evaluatorsTable.$el);
        self.getAllEvaluators(self.formData.id);
        self.getAssignedEvaluators(self.showInactiveEvaluators);
      };

      self.$ajaxGet(self, "Company/AssignEvaluatorToCompany?userId=" + userId + "&companyId=" + self.formData.id, onSuccess, onFinally);
    },
    unassignEvaluator(userId) {
      var self = this;
      self.showLoadingOnElement("assignedEvaluatorsTable", 1, "corners");

      var onSuccess = response => {
        self.$vs.notify({
          title: 'Information',
          color: "success",
          text: `Evaluator Unassigned from ${self.$siteTypeId() == 1 ? 'Topic' : 'Module'}`,
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-user-minus'
        });
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.assignedEvaluatorsTable.$el);
        self.getAllEvaluators(self.formData.id);
        self.getAssignedEvaluators(self.showInactiveEvaluators);
      };

      self.$ajaxGet(self, "Company/RemoveEvaluatorFromCompany?userId=" + userId + "&companyId=" + self.formData.id, onSuccess, onFinally);
    },
    getAssignedModerators(val) {
      const self = this;
      self.showLoadingOnElement("assignedModeratorsTable", 1, "corners");

      var onSuccess = function (response) {
        self.assignedModerators = response.data;
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.assignedModeratorsTable.$el);
        self.$refs.assignedModeratorsTable.searchx = "";
      };

      self.$ajaxGet(self, "Company/ListCompanyAssignedModerators?showInactive=" + val + "&companyId=" + self.formData.id, onSuccess, onFinally);
    },
    assignModerator(userId) {
      var self = this;
      self.showLoadingOnElement("moderatorsTable", 1, "corners");

      var onSuccess = response => {
        self.$vs.notify({
          title: 'Information',
          color: "success",
          text: `Moderator Assigned to ${self.$siteTypeId() == 1 ? 'Topic' : 'Module'}`,
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-user-check'
        });
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.moderatorsTable.$el);
        self.getAllModerators(self.formData.id);
        self.getAssignedModerators(self.showInactiveModerators);
      };

      self.$ajaxGet(self, "Company/AssignModeratorToCompany?userId=" + userId + "&companyId=" + self.formData.id, onSuccess, onFinally);
    },
    unassignModerator(userId) {
      var self = this;
      self.showLoadingOnElement("assignedModeratorsTable", 1, "corners");

      var onSuccess = response => {
        self.$vs.notify({
          title: 'Information',
          color: "success",
          text: `Moderator Unassigned from ${self.$siteTypeId() == 1 ? 'Topic' : 'Module'}`,
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-user-minus'
        });
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.assignedModeratorsTable.$el);
        self.getAllModerators(self.formData.id);
        self.getAssignedModerators(self.showInactiveModerators);
      };

      self.$ajaxGet(self, "Company/RemoveModeratorFromCompany?userId=" + userId + "&companyId=" + self.formData.id, onSuccess, onFinally);
    },
    saveEditCompany() {
      var self = this;
      
      self.$validator.validateAll().then(result => {
        if (result) {
          self.showLoadingOnSaveButton();

          self.formData.teacherId = self.teacherDropdown ? parseInt(self.teacherDropdown.value) : null;
          self.formData.courseId = self.subjectDropdown ? parseInt(self.subjectDropdown.value) : null;

          if (self.formData.year) {
            self.formData.year = self.formData.year.getFullYear();
          }

          var onSuccess = response => {
            self.isInfoHidden = true;
            self.scrollToNavbar();
            self.isCompanyListHidden = false;
            self.saveData();
            self.$vs.notify({
              title: "Information",
              color: "success",
              text: `${self.$siteTypeId() == 1 ? 'Classroom' : 'Company'} Saved`,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-save"
            });
          };
          var onFinally = function (){
            self.$vs.loading.close(self.$refs.saveEditButton.$el);
          };

          self.$ajaxPost(self, "Company/AddEditCompany", self.formData, onSuccess, onFinally);
        } else {
          self.$vs.notify({
            title: "Attention",
            color: "warning",
            text:  self.$validator.errors.items[0].msg,
            position: "top-right",
            iconPack: "feather",
            icon: "icon-info"
          });
        }
      });
    },
    cancelBulkAdd() {
      this.bulkCsvFileUrl = "";
      this.isBulkAddHidden = true;
      this.isLoading = false;
      this.canCancel = true;
      this.$vs.loading.close(this.$refs.bulkUpload.$el);
    },
    bulkStudentAdd() {
      if(this.$getsiteType != 1){
        this.uploadBulkStudentAddFile = true;
        return
      }
      this.isBulkAddHidden = false;
    },
    csvSuccessUpload(data) {
      this.isLoading = false;
      this.bulkCsvFileUrl = data[0].url;
    },
    confirmBulkStudentAdd() {
      var self = this;
      self.canCancel = false;
      self.showLoadingOnElement('confirmBulkButton', 0.35, 'material');

      var onSuccess = response => {
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: response.data,
          time: 7000,
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-info'
        });
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.confirmBulkButton.$el);
        self.cancelBulkAdd();
        self.getAssignedStudents(self.formData.id);
      };
      
      self.$ajaxGet(self, "Company/BulkStudentAdd?fileUrl=" + self.bulkCsvFileUrl + "&companyId=" + self.formData.id, onSuccess, onFinally);
    },
    getUnassignedStudents(companyId) {
      const self = this;
      self.showLoadingOnElement("unassignedStudentsTable", 1, "corners");

      var onSuccess = function (response) {
        self.unassignedStudents = [];

        if(self.criteria.unassignedPageNumber > 1)
          self.unassignedStudents[((self.criteria.unassignedPageNumber - 1) * self.criteria.unassignedPageSize) - 1] = {};

        self.unassignedStudents = self.unassignedStudents.concat(response.data.records);
          
        if (response.data.count > (self.criteria.unassignedPageNumber * self.criteria.unassignedPageSize))
            self.unassignedStudents[response.data.count - 1] = {};
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.unassignedStudentsTable.$el);
      };

      self.$ajaxGet(self, "Company/ListUnassignedStudents?companyId="+ companyId +"&pageNumber=" + self.criteria.unassignedPageNumber + "&pageSize=" + self.criteria.unassignedPageSize + "&searchPhrase=" + self.criteria.unassignedSearchPhrase, onSuccess, onFinally);
    },
    getAssignedStudents(companyId) {
      const self = this;
      self.showLoadingOnElement("assignedStudentsTable", 1, "corners");

      var onSuccess = function (response) {
        self.assignedStudents = [];

        if (self.criteria.assignedPageNumber > 1)
          self.assignedStudents[((self.criteria.assignedPageNumber - 1) * self.assignedPageSize) - 1] = {};

        self.assignedStudents = self.assignedStudents.concat(response.data.records);

        if (response.data.count > (self.criteria.assignedPageNumber * self.assignedPageSize))
          self.assignedStudents[response.data.count - 1] = {};
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.assignedStudentsTable.$el);
      };

      self.$ajaxGet(self, "Company/ListAssignedStudents?companyId=" + companyId + "&pageNumber=" + self.criteria.assignedPageNumber + "&pageSize=" + self.criteria.assignedPageSize + "&searchPhrase=" + self.criteria.assignedSearchPhrase, onSuccess, onFinally);
    },
    assignStudent(studentId) {
      var self = this;
      self.showLoadingOnElement("unassignedStudentsTable", 1, "corners");

      var onSuccess = response => {
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: `Student Assigned to ${self.$siteTypeId() == 1 ? 'Classroom' : 'Company'}`,
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-user-check'
        });

        
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.unassignedStudentsTable.$el);
        //self.getUnassignedStudents(self.formData.id);
        self.getAssignedStudents(self.formData.id);
        if ((self.unassignedStudents.length - 1) % 10 === 0 && self.criteria.unassignedPageNumber > 1) {
          //self.criteria.unassignedPageNumber -= 1;
          self.handleUnassignedStudentChangePage(self.criteria.unassignedPageNumber - 1);
        }
      };

      var siteType = self.$siteTypeId();

      self.$ajaxGet(self, "Company/AssignStudent?studentId=" + studentId + "&companyId=" + self.formData.id + "&siteType=" + siteType, onSuccess, onFinally);
    },
    unassignStudent(studentId) {
      var self = this;
      self.showLoadingOnElement("assignedStudentsTable", 1, "corners");

      var onSuccess = response => {
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: `Student Unassigned from ${self.$siteTypeId() == 1 ? 'Classroom' : 'Company'}`,
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-user-minus'
        });
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.assignedStudentsTable.$el);
        self.getUnassignedStudents(self.formData.id);
        self.getAssignedStudents(self.formData.id);
      };

      self.$ajaxGet(self, "Company/UnassignStudent?studentId=" + studentId + "&companyId=" + self.formData.id, onSuccess, onFinally);
    },
    showTransactionsPopup(student) {
      var self = this;

      self.selectedStudent.id = 0;
      self.selectedStudent.name = "";
      self.selectedStudent.transactions = [];
      
      self.getTransactions(student);
    },
    getTransactions(student) {
      const self = this;
      self.showLoadingOnElement("companyPage", 1, "corners");

      var onSuccess = function (response) {
        self.selectedStudent.id = student.id;
        self.selectedStudent.name = `${student.userFirstName} ${student.userLastName}`;
        self.selectedStudent.transactions = response.data;

        self.transactionsPopupActive = true;
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.companyPage.$el);
      };

      self.$ajaxGet(self, "Student/ListTransactions?studentId=" + student.id, onSuccess, onFinally);
    },
    addUploaderClickEvents() {
      var self = this;

      self.$refs.bulkUpload.$el.addEventListener("click", function(){
        if(!self.isLoading) {
          self.isLoading = true;
          self.showLoadingOnElement("bulkUpload", 0.45, "material");
        }else{
          self.isLoading = false;
          self.$vs.loading.close(self.$refs.bulkUpload.$el);
        }
      });
    },
    showLoadingOnSaveButton() {
      var self = this;
      self.$vs.loading({
        background: self.loadingColor,
        type: "material",
        container: self.$refs.saveEditButton.$el,
        scale: 0.45
      });
    },
    showLoadingOnTable() {
      var self = this;
      self.$vs.loading({
        type: "corners",
        container: self.$refs.companiesTable.$el,
        scale: 1
      });
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    scrollToNavbar() {
      var scrollOptions = {
        easing: "ease-in",
        offset: -500,
        force: true,
        cancelable: true,
        x: false,
        y: true
      };
      var cancelScroll = this.$scrollTo(
        document.getElementById("navbarGlobal"),
        500,
        scrollOptions
      );
    },
    scrollToFooter() {
      var scrollOptions = {
        easing: "ease-in",
        offset: -480,
        force: true,
        cancelable: true,
        x: false,
        y: true
      };
      var cancelScroll = this.$scrollTo(
        document.getElementById("footerGlobal"),
        100,
        scrollOptions
      );
    },
    handleUnassignedStudentChangePage(pageNumber) {
      var self = this;

      if(pageNumber > 0) {
        self.criteria.unassignedPageNumber = pageNumber;
        self.criteria.showInactive = self.showInactive;

        self.getUnassignedStudents(self.formData.id);
      }
    },
    handleUnassignedStudentsSearch(searchPhrase) {
      var self = this;

      if(searchPhrase.length >= 3){
        self.criteria.unassignedSearchPhrase = searchPhrase;

        self.getUnassignedStudents(self.formData.id);
      }
      else if (searchPhrase == ""){
        self.criteria.unassignedSearchPhrase = searchPhrase;
        self.getUnassignedStudents(self.formData.id);
      }
    },
    handleAssignedStudentChangePage(pageNumber) {
      var self = this;

      if (pageNumber > 0) {
        self.criteria.assignedPageNumber = pageNumber;
        self.criteria.showInactive = self.showInactive;

        self.getAssignedStudents(self.formData.id);
      }
    },
    handleAssignedStudentsSearch(searchPhrase) {
      var self = this;

      if(searchPhrase.length >= 3){
        self.criteria.assignedSearchPhrase = searchPhrase;

        self.getAssignedStudents(self.formData.id);
      }
      else if (searchPhrase == ""){
        self.criteria.assignedSearchPhrase = searchPhrase;
        self.getAssignedStudents(self.formData.id);
      }
    },
    getCurrentUserId() {
      var self = this;
	  
      var userIdFromLocalStorage = localStorage.getItem("Current_User_Id");

      if (userIdFromLocalStorage != undefined && userIdFromLocalStorage != null && userIdFromLocalStorage != "") {
        self.currentUserId = JSON.parse(userIdFromLocalStorage);
        return;
      }

      var onSuccess = response => {
        localStorage.setItem("Current_User_Id", response.data);
        self.currentUserId = JSON.parse(localStorage.getItem('Current_User_Id'));
      };
      self.$ajaxGet(self, "user/GetUserId", onSuccess);
    },
    handleAssignedModulesChangePage(pageNumber) {
      var self = this;
      
      if (pageNumber > 0) {
        self.criteria.assignedModulesPageNumber = pageNumber;
        self.getAssignedModules(self.formData.id);
      }
    },
    handleAssignedModulesSearch(searchPhrase) {
      var self = this;

      if(searchPhrase.length >= 3){
        self.criteria.assignedModulesSearchPhrase = searchPhrase;

        self.getAssignedModules(self.formData.id);
      }
      else if (searchPhrase == ""){
        self.criteria.assignedModulesSearchPhrase = searchPhrase;
        self.getAssignedModules(self.formData.id);
      }
    },
    getModulesDropdownList(companyId) {
      const self = this;

      var onSuccess = function (response) {
        self.unassignedModules = response.data.filter(function (item) {
          return !item.assigned;
        });
      };

      self.$ajaxGet(self, "company/getModulesDropdownList?companyId=" + companyId, onSuccess);
    },
    getAssignedModules(companyId) {
      const self = this;
      self.showLoadingOnElement("modulesTable", 1, "corners");

      var onSuccess = function (response) {
        self.assignedModules = [];

        if (self.criteria.assignedModulesPageNumber > 1)
          self.assignedModules[((self.criteria.assignedModulesPageNumber - 1) * self.criteria.assignedModulesPageSize) - 1] = {};

        self.assignedModules = self.assignedModules.concat(response.data.records);

        if (response.data.count > (self.criteria.assignedModulesPageNumber * self.criteria.assignedModulesPageSize))
          self.assignedModules[response.data.count - 1] = {};
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.modulesTable.$el);
        self.$refs.modulesTable.searchx = "";
      };

      self.$ajaxGet(self, "company/getAssignedModules?companyId=" + companyId + "&pageNumber=" + self.criteria.assignedModulesPageNumber + "&pageSize=" + self.criteria.assignedModulesPageSize + "&searchPhrase=" + self.criteria.assignedModulesSearchPhrase, onSuccess, onFinally);
    },
    areYouSure(moduleId) {
      this.moduleId = moduleId;
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Attention`,
        text: 'Are you sure you want to remove the selected module from the company?',
        accept: this.unassignModule,
        acceptText: "Yes",
        cancelText: "No"
      })
    },
    unassignModule() {
      var self = this;
      self.showLoadingOnElement("modulesTable", 1, "corners");

      self.companyAssignModule.companyId = self.formData.id;
      self.companyAssignModule.moduleId = self.moduleId;

      var onSuccess = response => {
        self.$vs.notify({
          title: 'Information',
          color: "success",
          text: "Module Unassigned from Company",
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-user-minus'
        });
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.modulesTable.$el);
        self.getModulesDropdownList(self.formData.id);
        self.getAssignedModules(self.formData.id);
      };

      self.$ajaxPost(self, "Company/UnassignModule",self.companyAssignModule, onSuccess, onFinally);
    },
    assignModule() {
      var self = this;

      if (self.modulesDropdown.value) {
        self.showLoadingOnElement("modulesTable", 1, "corners");

        self.companyAssignModule.companyId = self.formData.id;
        self.companyAssignModule.moduleId = self.modulesDropdown.value;

        var onSuccess = response => {
          self.$vs.notify({
            title: 'Information',
            color: "success",
            text: "Module Assigned to Company",
            position: 'top-right',
            iconPack: 'feather',
            icon: 'icon-user-check'
          });
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.modulesTable.$el);
          self.getModulesDropdownList(self.formData.id);
          self.getAssignedModules(self.formData.id);
          self.modulesDropdown = 0;
        };

        self.$ajaxPost(self, "Company/AssignModule", self.companyAssignModule, onSuccess, onFinally);
      }
    },
    downloadTemplate(){
      var self = this;
      window.open("https://lateralscaffolding.blob.core.windows.net/studentbulk/CompanyTemplate.csv");
    },
    queueLogbooks(){
      var self = this;
      self.showLoadingOnElement("companyPage",1,"corners");
      var onSuccess = response =>{
        self.$vs.notify({
          title: 'Information',
          color: "success",
          text: response.data,
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-user-check',
        });
      }
    
      var onFinally = response =>{
        if(self.$refs.companyPage){
          self.$vs.loading.close(self.$refs.companyPage.$el);
        }
      }
      var sendData = {
        mentorId: self.selectedMentor.value,
        companyId: this.formData.id,
        mentorNote: self.mentorNote,
      };

      self.$ajaxPost(self, "Company/QueueLogbooks" , sendData , onSuccess, onFinally);
    },
    getAssignedAndNotAssignedMonitors(){
      var self = this;
      self.showLoadingOnElement("notAssignMonitorsTable",1,"corners");
      var onSuccess = response =>{
        self.assignMonitors = response.data.filter(x=>x.assigned);
        self.notAssignMonitors = response.data.filter(x=>!x.assigned);
        self.monitorsLoaded = true;
      }
    
      var onFinally = response =>{
        if(self.$refs.notAssignMonitorsTable){
          self.$vs.loading.close(self.$refs.notAssignMonitorsTable.$el);
        }
      }
    
      self.$ajaxGet(self, `Company/MonitorAssigned?companyId=${this.formData.id}` , onSuccess, onFinally);
    },
    unassignMonitor(userId){
      var self = this;
      self.showLoadingOnElement("assignedMonitorsTable",1,"corners");
      var onSuccess = response =>{
        //self.getAssignedAndNotAssignedMonitors();
        self.notAssignMonitors.push(self.assignMonitors.filter(x=>x.userId == userId)[0])
        self.assignMonitors = self.assignMonitors.filter(x=>x.userId != userId)
        self.$vs.notify({
          title: 'Information',
          color: "danger",
          text: "Monitor Removed",
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-user-x',
        });
      }
    
      var onFinally = response =>{
        if(self.$refs.assignedMonitorsTable){
          self.$vs.loading.close(self.$refs.assignedMonitorsTable.$el);
        }
        
      }
    
      self.$ajaxGet(self, `Company/UnAssignMonitor?CompanyId=${this.formData.id}&userId=${userId}` , onSuccess, onFinally);
    },
    assignMonitor(userId){
      var self = this;
      self.showLoadingOnElement("notAssignMonitorsTable",1,"corners");
      var onSuccess = response =>{
        //self.getAssignedAndNotAssignedMonitors();
        self.assignMonitors.push(self.notAssignMonitors.filter(x=>x.userId == userId)[0])
        self.notAssignMonitors = self.notAssignMonitors.filter(x=>x.userId != userId)
        self.$vs.notify({
          title: 'Information',
          color: "success",
          text: "Monitor Added",
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-user-check',
        });
      }
    
      var onFinally = response =>{
        if(self.$refs.notAssignMonitorsTable){
          self.$vs.loading.close(self.$refs.notAssignMonitorsTable.$el);
        }
        
      }
    
      self.$ajaxGet(self, `Company/AssignMonitor?CompanyId=${this.formData.id}&userId=${userId}` , onSuccess, onFinally);
    },
    uploadComplete(error, file) {
      var self = this;
      this.bulkCsvFileAssignUrl = file.serverId;
      const reader = new FileReader();
      var text = reader.readAsText(file.file);
      reader.onload = function (e) {
        const text = e.target.result;
        self.csvToArray(text);
      };
    },
    uploadCompleteForBulkStudentAdd(error, file) {
      var self = this;
      if(error){
        self.$vs.notify({
          title: 'Information',
          color: "warning",
          text: "Something Went Wrong Try again",
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-user-check',
        });
      }
      var fileData = JSON.parse(file.serverId);
      this.bulkCsvStudentAssignUrl = fileData.url;
      const reader = new FileReader();
      var text = reader.readAsText(file.file);
      reader.onload = function (e) {
        const text = e.target.result;
        self.csvToArrayBulkStudent(text);
      };
    },
    clearFilepond(){
      var self = this;
      if(this.$refs.pond){
        self.$refs.pond.getFiles().forEach(element => {
          self.$refs.pond.removeFile(element);
        });
      }
    },
    clearFilepond2(){
      var self = this;
      if(this.$refs.pond2){
        self.$refs.pond2.getFiles().forEach(element => {
          self.$refs.pond2.removeFile(element);
        });
      }
    },
    csvToArray(str, delimiter = ",") {
      var self = this;
      self.errorAtLines = [];
      const headers = str.slice(0, str.indexOf("\n")).split(delimiter);
      if(headers.length != 2){
        self.$vs.notify({
          title: 'Information',
          color: "warning",
          text: "Wrong Headers",
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-user-check',
        });
        return 
      }
      const rows = str.slice(str.indexOf("\n") + 1).split("\n");
      var index = 1;
      rows.forEach(element => {
        index++;
        var items = element.split(delimiter).length;
        if(element == ""){
          return;
        }
        if(items != 2){
          self.bulkUploadRows.push({
            error:true,
            row:element,
            index:index,
          });
          self.errorAtLines.push(index);
        }
        else{
          self.bulkUploadRows.push({
            error:false,
            row:element,
            index:index,
          });
        }
      });
      self.showBulkStudentValidation = true;
      self.clearFilepond();
    },
    csvToArrayBulkStudent(str, delimiter = ",") {
      var self = this;
      self.errorAtLines = [];
      self.bulkAddStudentUploadRows = [];

      self.showLoadingOnElement("companyPage",1,"corners");

      const headers = str.slice(0, str.indexOf("\n")).split(delimiter);
      if(headers.length != 8){
        self.$vs.notify({
          title: 'Information',
          color: "warning",
          text: "Wrong Headers",
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-user-check',
        });
        return 
      }
      const rows = str.slice(str.indexOf("\n") + 1).split("\n");
      var index = 1;
      rows.forEach(element => {
        index++;
        var items = element.split(delimiter);
        if(element == ""){
          return;
        }
        var studentObject = {
          error:false,
          index:index,
          lastName:"",
          firstName:"",
          work:"",
          mobile:"",
          email:"",
          password:"",
          idNumber:""
        }
        if(items.length != 8){
          studentObject.error = true
          self.errorAtLines.push(index);
        }
        studentObject.lastName = items[0];
        studentObject.firstName = items[1];
        studentObject.work = items[2];
        studentObject.mobile = items[3];
        studentObject.email = items[4];
        studentObject.password = items[5];
        studentObject.idNumber = items[6];
        
        self.bulkAddStudentUploadRows.push(studentObject);
      });

      setTimeout(() => {
        if(this.$refs.companyPage){
          this.$vs.loading.close(this.$refs.companyPage.$el);
        }
        self.showBulkStudentAddValidation = true;
        self.uploadBulkStudentAddFile = false;
      }, 200);
      self.clearFilepond2();
    },
    fileRemoved(error, file) {
    },
    cancelBulkStudentAddValidation(){
      this.bulkCsvStudentAssignUrl = "";
      this.bulkAddStudentUploadRows = [];
      this.showBulkStudentAddValidation = false;
    },
    cancelBulkUpload(){
      var self = this;
      this.bulkUploadRows = [];
      this.showBulkStudentValidation = false;
      this.errorAtLines = [];
    },
    uploadBulkStudentCSV(){
      var self = this;
      var csv = {
        url:self.bulkCsvStudentAssignUrl,
        companyId:self.formData.id
      }
      self.showLoadingOnElement("companyPage",1,"corners");
      self.$ajaxPost(self, "Company/BulkUploadStudentsNew" , csv , ()=>{}, ()=>{});

      self.showBulkStudentAddValidation = false;
      self.uploadBulkStudentAddFile = false;

      setTimeout(() => {
        if(this.$refs.companyPage){
          this.$vs.loading.close(this.$refs.companyPage.$el);
        }
        
        self.$swal({
            title: 'The batch is being proccessed',
            icon:'success',
            html: `A notification will be added once completed.`,
            customClass: {
              confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled',
            },
            buttonsStyling: false,
          });
      }, 200);
    },
    UploadCSVAssign(){
      var self = this;
      var onSuccess = response =>{

      }
    
      var onFinally = response =>{
        
      }
      var csvData = {
        url : self.bulkCsvFileAssignUrl
      }
      
      self.$ajaxPost(self, `Company/BulkAssignStudents`,csvData , onSuccess, onFinally);

      self.cancelBulkUpload();
      self.$vs.notify({
        title: 'Information',
        color: "success",
        text: "Uploaded Waiting For Processing",
        position: 'top-right',
        iconPack: 'feather',
        icon: 'icon-file',
      });
    },
    downloadTemplateBulkAssing(){
      window.open("https://lateralscaffolding.blob.core.windows.net/studentbulk/UserList.csv");
    }
  },
  mounted() {
    var self = this;
    self.getCurrentUserId();
    self.showLoadingOnTable();
    self.loadCompanyData();
    document.getElementsByClassName("input-search")[0].innerText = "";
    self.$refs.companiesTable.searchx = "";
    self.getTeachers();
    self.getSubjects();

    // Paging for Assigned Students
    self.criteria.assignedPageSize = self.assignedPageSize;
    self.criteria.assignedPageNumber = self.$refs.assignedStudentsTable.currentPage;

    // Paging for Unassigned Students
    self.criteria.unassignedPageSize = self.unassignedPageSize;
    self.criteria.unassignedPageNumber = self.$refs.unassignedStudentsTable.currentPage;

    // Paging for Assigned modules
    self.criteria.assignedModulesPageSize = self.assignedModulesPageSize;
    self.criteria.assignedModulesPageNumber = self.$refs.modulesTable.currentPage;

  }
};
</script>
<style lang="scss">
  #bulkNotAddedPopup div.vs-popup {
    width: 1000px;
  }

  div#bulkNotAddedPopup.vs-component.con-vs-popup.vs-popup-primary {
    div.vs-popup {
      header.vs-popup--header {
        i.vs-icon.notranslate.icon-scale.vs-popup--close.vs-popup--close--icon.material-icons.null {
          background: rgb(253, 0, 0) !important;
          color: rgb(255, 255, 255);
        }
      }
    }
  }

  div#transactionsPopup.vs-component.con-vs-popup.vs-popup-primary {
    div.vs-popup {
      header.vs-popup--header {
        i.vs-icon.notranslate.icon-scale.vs-popup--close.vs-popup--close--icon.material-icons.null {
          background: rgb(253, 0, 0) !important;
          color: rgb(255, 255, 255);
        }
      }
    }
  }

  #container-of-collapses .open-item .vs-collapse-item--content {
    max-height: fit-content !important;
  }
 #companyPage{
    .vs-collapse.border.default {
      background: #ffffff !important;
    }
 }

 .uploadFeedback{
    .vs-popup{
      width: unset !important;
    }
 }
  
</style>
